import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import styles from "../../pages/Company.module.css";

const MembersTable = ({ members, onEdit, onRemove, onInvite }) => {
  const { t } = useTranslation();
  const [openMenuId, setOpenMenuId] = useState(null);

  useEffect(() => {
    const handler = () => setOpenMenuId(null);
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  return (
    <div className={styles.membersSection}>
      <div className={styles.membersHeader}>
        <h2 className="section-title">{t('members.title')}</h2>
        <button className={`button ${styles.addMemberButton}`} onClick={onInvite}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M9.25 17V10.75H3V9.25H9.25V3H10.75V9.25H17V10.75H10.75V17H9.25Z" fill="white" />
          </svg>
          {t('members.add')}
        </button>
      </div>

      <table className={styles.membersTable}>
        <thead>
          <tr>
            <th>{t('members.col_name')}</th>
            <th>{t('members.col_email')}</th>
            <th>{t('members.col_role')}</th>
            <th>{t('members.col_status')}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {members.map((member, i) => (
            <tr key={member.id ?? `inv-${i}`}>
              <td>{member.full_name}</td>
              <td>{member.email}</td>
              <td>{member.role === "admin" ? t('members.role_admin') : t('members.role_member')}</td>
              <td>
                {member.status === "active" ? (
                  <span className={styles.badgeActive}>
                    <CheckCircleOutlineIcon style={{ fontSize: 14 }} /> {t('members.status_active')}
                  </span>
                ) : (
                  <span className={styles.badgeInvited}>
                    <AutorenewIcon style={{ fontSize: 14 }} /> {t('members.status_invited')}
                  </span>
                )}
              </td>
              <td className={styles.menuCell}>
                <button
                  className={styles.menuTrigger}
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpenMenuId(openMenuId === i ? null : i);
                  }}
                >
                  ⋮
                </button>
                {openMenuId === i && (
                  <div className={styles.dropdownMenu}>
                    {member.status === "active" && (
                      <button onClick={() => { onEdit(member); setOpenMenuId(null); }}>
                        <EditOutlinedIcon fontSize="small" /> {t('members.edit')}
                      </button>
                    )}
                    <button
                      className={styles.deleteBtn}
                      onClick={() => { onRemove(member); setOpenMenuId(null); }}
                    >
                      <DeleteOutlineIcon fontSize="small" /> {t('members.delete')}
                    </button>
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MembersTable;
